interface DimensionsIcon {
  width: number;
  height: number;
  className? : string;
}

export const IconClipBoard = ({width, height, className}: DimensionsIcon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
  >
    <path
      d="M9.5 2A1.5 1.5 0 0 0 8 3.5v1A1.5 1.5 0 0 0 9.5 6h5A1.5 1.5 0 0 0 16 4.5v-1A1.5 1.5 0 0 0 14.5 2h-5Z"
    />
    <path
      fillRule="evenodd"
      d="M6.5 4.037c-1.258.07-2.052.27-2.621.84C3 5.756 3 7.17 3 9.998v6c0 2.829 0 4.243.879 5.122.878.878 2.293.878 5.121.878h6c2.828 0 4.243 0 5.121-.878.879-.88.879-2.293.879-5.122v-6c0-2.828 0-4.242-.879-5.121-.569-.57-1.363-.77-2.621-.84V4.5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3v-.463ZM7 9.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5H7Zm3.5 0a.75.75 0 0 0 0 1.5H17a.75.75 0 0 0 0-1.5h-6.5ZM7 13.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5H7Zm3.5 0a.75.75 0 0 0 0 1.5H17a.75.75 0 0 0 0-1.5h-6.5ZM7 16.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5H7Zm3.5 0a.75.75 0 0 0 0 1.5H17a.75.75 0 0 0 0-1.5h-6.5Z"
      clipRule="evenodd"
    />
  </svg>
)

